import { Events as ScrollEvents } from "./scroll-handler.js";
import { CarouselFeature } from "./feature-base.js";
const SlideVisibilityAnnouncementThrottle = 50;
class SlideVisibilityFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.controlledUpdate = true;
    this.slideVisibilityUpdateCallback = ({ scrollLeft }) => this.micro(
      () => this.updateVisibleSlides(scrollLeft),
      "update visible slides index",
      SlideVisibilityAnnouncementThrottle
    );
    // Sets the amount of surface percentage required of a slide to be visible to be considered as displayed.
    this.visibilityPercentThreshold = 0.95;
    // If 95% of a slide is visible it will considered displayed.
    // Evaluates each slide's visibility and dispatches an event if a change can be detected in the result.
    this.updateVisibleSlides = (scrollLeft = this.host.scrollLeft) => {
      const clientWidth = this.host.clientWidth;
      this.slidesVisibilityRatio.length = 0;
      const visibleSlides = [];
      const containerLeftEdge = scrollLeft;
      const containerRightEdge = containerLeftEdge + clientWidth;
      const scrollWidth = this.host.scrollContainer.scrollWidth;
      this.host.assignedChildren.forEach((el, i) => {
        const toleranceMargin = el.clientWidth * (1 - this.visibilityPercentThreshold);
        if (el.offsetLeft + toleranceMargin >= scrollLeft && el.offsetLeft + el.clientWidth - toleranceMargin <= scrollLeft + clientWidth) {
          visibleSlides.push(i);
        }
        if (el.clientWidth) {
          const leftEdge = el.offsetLeft;
          const rightEdge = leftEdge + el.clientWidth;
          const isAtScrollStart = leftEdge <= 1;
          const isAtScrollEnd = rightEdge >= scrollWidth - 1;
          const adjustedContainerLeftEdge = containerLeftEdge + (isAtScrollStart ? 0 : this.host.controls.controllerWidth);
          const adjustedContainerRightEdge = containerRightEdge - (isAtScrollEnd ? 0 : this.host.controls.controllerWidth);
          const offScreenLeft = -Math.min(
            leftEdge - adjustedContainerLeftEdge,
            0
          );
          const offScreenRight = Math.max(
            rightEdge - adjustedContainerRightEdge,
            0
          );
          const visibleAmount = Math.max(el.clientWidth - (offScreenLeft + offScreenRight), 0) / el.clientWidth;
          this.slidesVisibilityRatio.push(visibleAmount);
        } else {
          this.slidesVisibilityRatio.push(0);
        }
      });
      if (this.__visibleSlides.toString() !== visibleSlides.toString()) {
        if (this.controlledUpdate && // if its marked as controlled update
        this.host.slideIndex !== null && // and slideIndex is defined
        !visibleSlides.includes(
          clamp(this.host.slideIndex, 0, this.host.assignedChildren.length - 1)
        )) {
          this.controlledUpdate = false;
        }
        const slideVisibilityEvent = new SlideVisibilityEvent(
          visibleSlides,
          this.controlledUpdate
        );
        this.host.dispatchEvent(slideVisibilityEvent);
        this.controlledUpdate = false;
        this.__visibleSlides.length = 0;
        this.visibleSlides.push(...visibleSlides);
      }
    };
    this.__visibleSlides = [];
    this.__slidesVisibilityRatio = [];
  }
  // Report true on mount.
  connectedCallback() {
    this.host.features.scroller.addEventListener(
      ScrollEvents.UPDATE,
      this.slideVisibilityUpdateCallback
    );
  }
  disconnectedCallback() {
    this.host.features.scroller.removeEventListener(
      ScrollEvents.UPDATE,
      this.slideVisibilityUpdateCallback
    );
    this.micro(() => void 0, "update visible slides index", 50);
  }
  get visibleSlides() {
    return this.__visibleSlides;
  }
  get slidesVisibilityRatio() {
    return this.__slidesVisibilityRatio;
  }
}
class SlideVisibilityEvent extends Event {
  constructor(detail, controlled) {
    super("skapa-carousel-visible-slides", { bubbles: false });
    this.detail = detail;
    this.controlled = controlled;
  }
}
function clamp(x, min, max) {
  return x > max ? max : x < min ? min : x;
}
export {
  SlideVisibilityEvent,
  SlideVisibilityFeature
};
